import { render, staticRenderFns } from "./StihlServiceIcon.vue?vue&type=template&id=5b2b440e&"
import script from "./StihlServiceIcon.vue?vue&type=script&lang=js&"
export * from "./StihlServiceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports